module.exports = __webpack_public_path__ + "img/button_EndoTower-Bild.8426b2b7.png";